<template>
  <span class="d-inline-flex align-center flex-no-wrap scrap">
    <img class="icon" src="@/assets/img/scrap.png" alt="scrap icon">
    <span v-show="!hideValue" class="lh-1 font-weight-bold">{{ amount | toScrap }}</span>
  </span>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      required: true,
    },
    hideValue: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.scrap {
  position: relative;
}

.icon {
  position: absolute;
  z-index: 1;
  top: -0.2em;
  left: 0;
  width: 1.4em;
  height: 1.4em;
  user-select: none;
  pointer-events: none;
}

span {
  position: relative;
  z-index: 2;
  padding-left: 0.8em;
}
</style>
